import { useQuery } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const getClients = async param => {
  const token = localStorage.getItem('token');
  return customAxios({
    method: 'get',
    url: `/clients/${param}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

const useGetClients = param => useQuery(['clients', param], () => getClients(param), { enabled: true });

export default useGetClients;
